// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"f0e4b0ec","408":"301ce375","453":"912c25db"}[chunkId] + ".chunk.js";
};